// A card, enlarged for inspection. The dialog is native, so showModal() traps
// focus, Escape closes it and focus goes back to the card that opened it; the
// X is a method="dialog" form and needs none of this. What is left for script
// is opening it, and closing it when a click lands on the backdrop.
function start() {
  document.querySelectorAll("[data-card-zoom-open]").forEach((opener) => {
    if (opener.dataset.cardZoomReady === "true") return;
    const dialog = document.getElementById(opener.getAttribute("aria-controls"));
    if (!dialog || typeof dialog.showModal !== "function") return;
    opener.dataset.cardZoomReady = "true";

    opener.addEventListener("click", () => dialog.showModal());
    // The dialog is exactly the card's size, so a click whose target is the
    // dialog element itself came through the backdrop around it.
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
  });
}

document.addEventListener("DOMContentLoaded", start);
document.addEventListener("turbo:load", start);
